"use strict";

class DeveloperAPIConfigController {

    constructor($scope, $timeout, SSHttpService, SSUtilService, SSDateService, SSAwsService, SSAppService, SSAlertService, SSUserService, SSConfigService, SSConfirmationService, SSAnalyticsService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.data = SHOWSUITE.data;
        self.role_id = null;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        // Trigger View Event for API Configuration Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_API_CONFIGURATION,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.getExtClients();
        self.getProjectsList();
    }

    getProjectsList(){
        const self = this;

        self.properties = [];

        let url = 'sec/developer/properties/list';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.properties){
                $.each(response.data.properties, function(index, property){
                    if(property.status != self.PROPERTY_STATUS_ARCHIVED){
                        self.properties.push(property);
                    }
                });
            }

        });
    }

    getExtClients() {
        let self = this;

        if (!self.SSUserService.hasPermission('DMS_VIEW_API')) { return false; }

        let url = 'sec/developer/ext-clients';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.ext_clients = response.data.ext_clients;

            $.each(self.ext_clients, function(index, ext_client) {
                ext_client.processed_allowed_ips = ext_client.allowed_ips.split(',');
                ext_client.is_enabled = ext_client.is_enabled === 1;
                ext_client.save_change_set = ext_client.save_change_set === 1;
            });
        });
    }

    createExtClient() {
        const self = this;

        self.selected_ext_client = {};

        self.hideModal();

        self.initSelectizeProjectDDL();
        
        self.showExtClientEditModal = true;
        $('#extClientEditModal').modal('show');
    }

    editExtClient(ext_client) {
        const self = this;

        self.selected_ext_client = angular.copy(ext_client);
        self.read_ext_client = ext_client;

        self.selected_ext_client.processed_allowed_ips = self.selected_ext_client.allowed_ips.replace(/,/g, '\n');
        self.hideModal();

        self.initSelectizeProjectDDL(ext_client);

        self.showExtClientEditModal = true;
        $('#extClientEditModal').modal('show');
    }

    initSelectizeProjectDDL(obj) {
        const self = this;

        self.clearSelectize('selectize_property_ids');

        // Selectize documentation link: https://github.com/selectize/selectize.js/blob/master/docs/usage.md

        let project_ids = [];

        if(obj && obj.property_ids && obj.property_ids.length > 0){
            $.each(obj.property_ids.split(','), function(index, id){
                project_ids.push(id);
            });
        }

        self.selected_ext_client.property_ids = angular.copy(project_ids);

        self.$timeout(function(){
            let $select = $('#selectize_property_ids').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'desc',
                maxItems: null,
                options: self.properties,
                items: project_ids,
                searchField: ['name']
            });
        });
    }

    clearSelectize(id){
        const self = this;

        if(!id){
            return;
        }

        self.errName = null;
        self.errIpAddresses = null;

        try{
            let selectize = $("#" + id)[0].selectize;

            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }
    }


    viewSecretKey(id) {
        const self = this;

        self.hideModal();
        let url = 'sec/developer/ext-clients/' + id;
        self.selected_ext_client = {};

        loading(true);
        self.SSHttpService.getAPIRequest(url, { include_secret_key: true }).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.selected_ext_client = response.data.ext_clients[0];
            self.selected_ext_client.processed_view_allowed_ips = self.selected_ext_client.allowed_ips.split(',');

            self.showExtClientDetailsModal = true;
            $('#extClientDetailsModal').modal('show');
        });        
    }

    hideModal() {
        const self = this;

        self.showExtClientDetailsModal = false;
        self.showExtClientEditModal = false;

        if ($('#extClientDetailsModal').is(':visible')) $('#extClientDetailsModal').modal('hide');
        if ($('#extClientEditModal').is(':visible')) $('#extClientEditModal').modal('hide');
    }

    processedIpAddress() {
        const self = this;

        self.selected_ext_client.allowed_ips = self.selected_ext_client.processed_allowed_ips.replace(/\n/g, ',');
    }

    postExtClient() {
        const self = this;

        self.processedIpAddress();
        if (!self.validateExtClient()) return;

        let url = 'sec/developer/ext-clients';

        let params = angular.copy(self.selected_ext_client);
        if(params.property_ids && params.property_ids.length)
            params.property_ids = params.property_ids.join();

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            self.hideModal();
            self.getExtClients();
        });
    }

    putExtClient() {
        const self = this;

        self.processedIpAddress();
        if (!self.validateExtClient()) return;

        let url = 'sec/developer/ext-clients/' + self.selected_ext_client.id;

        let params = angular.copy(self.selected_ext_client);
        if(params.property_ids && params.property_ids.length)
            params.property_ids = params.property_ids.join();

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            let data = response.data.ext_clients[0]
            self.read_ext_client.name = data.name;
            self.read_ext_client.allowed_ips = data.allowed_ips;
            self.read_ext_client.processed_allowed_ips = self.read_ext_client.allowed_ips.split(',');
            self.read_ext_client.property_ids = data.property_ids;
            self.read_ext_client.is_enabled = data.is_enabled === 1;
            self.read_ext_client.save_change_set = data.save_change_set === 1;

            self.hideModal();
        });
    }

    validateExtClient() {
        const self = this;

        let error = false;
        let re = /^[a-zA-Z0-9_]+$/;;
        self.errName = '';
        self.errIpAddresses = '';

        if (!self.selected_ext_client.name) {
            self.errName = 'Name is required';
            error = true;
        }

        if (!self.selected_ext_client.allowed_ips) {
            self.errIpAddresses = 'IP Addresses are required';
            error = true;
        }

        // if (self.selected_ext_client.name != '' && !re.test(self.selected_ext_client.name)) {
        //     self.errName = 'Only alphabets, numbers and underscore are allowed';
        //     error = true;
        // }

        return !error;
    }

    deleteExtClient(id) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this external client?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/developer/ext-clients/' + id + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    jQuery.each(self.ext_clients, function (i, e) {
                        if (e.id == id) {
                            self.ext_clients.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Removed successfully.');
                });
            }
        );
    }
}

DeveloperAPIConfigController.$inject = ['$scope', '$timeout', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAwsService', 'SSAppService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSConfirmationService', 'SSAnalyticsService'];
app.controller('DeveloperAPIConfigController', DeveloperAPIConfigController);